import { render, staticRenderFns } from "./BeforePostingBlock.vue?vue&type=template&id=3191acd8&"
import script from "./BeforePostingBlock.vue?vue&type=script&lang=js&"
export * from "./BeforePostingBlock.vue?vue&type=script&lang=js&"
import style0 from "./BeforePostingBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
